
export const validateEmail = address =>
(/^([a-zA-Z0-9_.-]+){1,}@([\da-z.-]+){2,}\.([a-z.]{2,6})$/).test(address)

export const validateJustNumbers = phoneNumber =>
(/^\d+$/).test(phoneNumber)